import React from 'react';
import { Card, Typography } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import SoftLoadingProps from './SotftLoadingProps';
import useSx from './sx';

const SoftLoading = ({ isOpen }: SoftLoadingProps) => {
  const sx = useSx(isOpen);
  return (
    <Card sx={sx.paper} className="SoftLoading">
      <CircularProgress />
      <Typography sx={sx.loadingText}>Descargando ...</Typography>
    </Card>
  );
};

export default SoftLoading;
